module.exports = __webpack_public_path__ + "img/laptop-mobile-duotone.a71b6cda.svg";